import * as React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { QuestionItemSelectDashed } from '../../../figma/QuestionItemSelect/QuestionItemSelectDashed';
import { QuestionV2 } from '../../../figma/Question/QuestionV2';

const Main = styled.div`
  &:not(:last-child) {
    margin-bottom: 16px;
  }
  .question {
    display: inline;
    * {
      display: inline;
    }
    .question-no,
    .question-do-test {
      margin-right: 12px;
    }
  }
`;
const Content = styled.div``;

interface QuestionSelectMobileProps {
  no: string | number;
  withDot?: boolean;
  noArrow?: boolean;
  text?: string;
  options?: any;
  userAnswer?: number;
  withAbc?: boolean;
  onSelect: (input) => void;
}

export const QuestionSelectMobile = observer((props: QuestionSelectMobileProps) => {
  const { no, withDot, noArrow, text, options, userAnswer, withAbc, onSelect } = props;

  return (
    <Main className="question-select-mobile">
      <Content className="question">
        <QuestionV2 no={no} id={`question-no-${no}`} noArrow={noArrow} withDot={withDot} />
        <QuestionItemSelectDashed
          text={text}
          options={options}
          userAnswer={userAnswer}
          withAbc={withAbc}
          onSelect={onSelect}
        />
      </Content>
    </Main>
  );
});
